module.exports = __webpack_public_path__ + "img/tag.0c9ce5a7.svg";